export const TYPE_TAB = 1;
export const DATA_TAB = 2;
export const ROW_FILTER_TAB = 3;
export const BOOKING_FILTER_TAB = 4;
export const SMART_FILTER_TAB = 5;
